import { PEER_APP_DATA_MAX_SIZE_BYTES } from '../constants/common';
import OperationError from '../errors/OperationError';

const validateAppData = (appData: Record<string, unknown>): void => {
  let validStringifiesJsonAppData: string | undefined = undefined;

  try {
    validStringifiesJsonAppData = JSON.stringify(appData);
  } catch (error) {
    throw new OperationError('app_data_stringify_failed', error);
  }

  const size = new TextEncoder().encode(validStringifiesJsonAppData).length;

  if (size <= PEER_APP_DATA_MAX_SIZE_BYTES) {
    return;
  }

  throw new OperationError('app_data_size_exceeded');
};

export default validateAppData;
